<div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="100" (scrolled)="onScroll()"
  [scrollWindow]="true">
  <div [ngClass]="notificationlist.length === 0 ? 'notofication ht0' : 'notofication'">
    <div *ngIf="notificationlist.length > 0">
      <div class="notification-card" *ngFor="let item of notificationlist" (click)="redirectTo(item)">
        <div class="info-label" [innerHTML]="replaceURLWithHTMLLinks(item.msg)"></div>
        <div class="secondary-label">{{item.addedAt | date: 'h:mm a - MMM d'}}</div>
      </div>
    </div>
    <div class="notifications-div" *ngIf="notificationlist.length === 0">
      <h3 translate="">lbl_notifications_not_available</h3>
    </div>
  </div>
</div>